
import { SubDomain } from "../SubDomain.js";
import InvoiceSettings from "./InvoiceSettings.js";

export default class InvoiceSettingsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, InvoiceSettings.MODEL_NAME);
    this.storage = storage;
  }
  
  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new InvoiceSettings(this.domain, item);
      }
    }

    return new InvoiceSettings(this.domain, {});
  }
  
  findByCompany(company) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var settings = new InvoiceSettings(this.domain, item);
      if (settings.company().id() === company.id()) {
        return settings;
      }
    }
    return new InvoiceSettings(this.domain, {});
  }
}